const jobCandidateStatus: any = {
  'candidate-pool': null,
  screen: [2],
  'in-progress': [1, 3, 4],
  offered: [4],
  hired: [5],
  rejected: [6],
};
export default jobCandidateStatus;
